var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentCOlor",
  d: "M14.712 4.1a.53.53 0 0 0-.584 0l-2.932 1.758a.16.16 0 0 1-.136 0 .2.2 0 0 1-.113-.085L8.463 1.424a.555.555 0 0 0-.926 0L5.054 5.773a.2.2 0 0 1-.114.085.16.16 0 0 1-.136 0l-2.932-1.78a.53.53 0 0 0-.583 0 .55.55 0 0 0-.221.542l1.31 6.562a1.25 1.25 0 0 0 1.224 1.003h8.797a1.25 1.25 0 0 0 1.224-1.003l1.31-6.541a.55.55 0 0 0-.221-.54"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 2.662A1.33 1.33 0 1 0 8 0a1.33 1.33 0 0 0 0 2.662M1.33 5.246a1.33 1.33 0 1 0 0-2.662 1.33 1.33 0 0 0 0 2.662M14.676 5.246a1.331 1.331 0 1 0 0-2.662 1.331 1.331 0 0 0 0 2.662"
})));
export default SvgCrown;